if (localStorage.getItem("translations") === null) {

    async function updateTranslations() {
        if (!window.theme.strings.gwpEn) {
            window.theme.strings.gwpEn = await window.getEnTranslations();
            localStorage.setItem("translations", JSON.stringify(window.theme.strings.gwpEn));
        }
    }

    updateTranslations();

}

if (localStorage.getItem("productCache") === null) {
    localStorage.setItem("productCache", JSON.stringify({}));
}

window.updateCartCache = function (cart) {
    localStorage.setItem("cart", JSON.stringify(cart));
}

window.getCartCache = function () {
    return JSON.parse(localStorage.getItem("cart"));
}

window.setProductCache = function (id, data) {
    let productCache = JSON.parse(localStorage.getItem("productCache"));

    productCache[id] = data;
    localStorage.setItem("productCache", JSON.stringify(productCache));
}


window.clearCodeStack = function () {
    // Return full code stack array
    return localStorage.setItem("codeStack", JSON.stringify([]));
}

window.setCodeStack = function (code) {
    // add code to codestack array, return unique array
    let codeStack = window.getCodeStack();
    codeStack.push(code);
    localStorage.setItem("codeStack", JSON.stringify([...new Set(codeStack)]));

    return window.hasCodeStack(code);
}

window.getCodeStack = function () {
    // Return full code stack array
    return JSON.parse(localStorage.getItem("codeStack")) || [];
}

window.hasCodeStack = function (code) {
    // Return boolean if code exists in codeStack
    let codeStack = window.getCodeStack();
    return codeStack.length ? codeStack.includes(code) : false;
}

window.hasDmCodeStack = function () {
    // Return boolean if code exists in codeStack, made for DM customer code
    let codeStack = window.getCodeStack();

    for (let i = 0; i < codeStack.length; i++) {
        codeStack[i];
        if (codeStack[i][0] === "D" && codeStack[i][1] === "M") {
            return true;
        }

    }

    return false;
}


window.getCodeStackHtml = function () {
    // Return full code stack array as HTML
    // Return false if empty
    let codeStack = window.getCodeStack();
    let htmlString = '';

    if (codeStack.length) {
        for (let i = 0; i < codeStack.length; i++) {
            let theCode = codeStack[i];
            htmlString = htmlString + `<span class="badge badge-dark">${codeStack[i]} <i class="close fa-fw fas fa-times" onClick="window.removeCodeStack('${theCode}');window.refreshMiniCart();"></i></span>`;
        }
    } else {
        return false;
    }

    return htmlString;
}

window.removeCodeStack = function (code) {
    // loop and remove code if it exists
    let codeStack = window.getCodeStack();

    if (codeStack.length) {
        for (let i = 0; i < codeStack.length; i++) {
            if (code.toUpperCase() === codeStack[i].toUpperCase()) {
                codeStack.splice(i, 1);
            }
        }
    } else {
        return false;
    }

    localStorage.setItem("codeStack", JSON.stringify([...new Set(codeStack)]));
    return window.getCodeStack();
}

window.removeDmCodeStack = function () {
    // loop and remove code if it exists
    let codeStack = window.getCodeStack();

    if (codeStack.length) {
        for (let i = 0; i < codeStack.length; i++) {
            if (codeStack[i][0].toUpperCase() === "D" && codeStack[i][1].toUpperCase() === "M") {
                codeStack.splice(i, 1);
            }
        }
    } else {
        return false;
    }

    localStorage.setItem("codeStack", JSON.stringify([...new Set(codeStack)]));
    return window.getCodeStack();
}


window.getProductCache = function (id) {
    return JSON.parse(localStorage.getItem("productCache"))[id];
}

window.showGallery = function (barcode, index) {
    $('#dior-gallery').show();
    $('body').css("overflow-y", "hidden");
    $(`#fullscreen-mobile-images-${barcode}`).carousel(index);
    $(`#dior-fullscreen-carousel`).carousel(index);
    $(`#dior-fullscreen-carousel`).attr('style', 'display: block !important;');

    if ($("#dior-fullscreen-controls")[0].scrollHeight > $("#dior-fullscreen-controls").height()) {
        $('#fullscreen-up').show();
        $('#fullscreen-down').show();
    } else {
        $('#fullscreen-up').hide();
        $('#fullscreen-down').hide();
    }
}

window.hideGallery = function () {
    $('#dior-gallery').hide();
    $('body').css("overflow-y", "scroll");
}

document.addEventListener("DOMContentLoaded", function (event) {
    let cart = window.getCartCache();
    var totalCount = 0;

    if (cart) {
        let totalCount = cart.item_count;

        for (let i = 0; i <= cart.items.length - 1; i++) {
            if (window.constants.giftMessage == cart.items[i].id ||
                window.constants.giftMessageMaison == cart.items[i].id ||
                window.constants.invitationOffer == cart.items[i].id ||
                window.constants.freeGift == cart.items[i].id ||
                window.constants.engraveId == cart.items[i].id) {
                totalCount -= cart.items[i].quantity;
            }
        }

        if (totalCount > 0) {
            $("#cart-count").html(totalCount);
            $("#cart-count").show();
        }

    } 

    $(".search-form").on("submit", function (e) {
        if ($(this).find('.search-field').val().length == 0) {
            e.preventDefault();
            return false;
        }
    });

    $("body").show();
});

